import { useMutation } from '@apollo/client';
import { DELETE_PREREQUISITE_MUTATION } from '../../mutations';

export function useDeletePrerequisiteMutation() {
    return useMutation( DELETE_PREREQUISITE_MUTATION );
}
